import { loadStateSnapshot } from '../reducers/localStorage';

/**
 * Return the exact serialized state the existing migration recovery path chose.
 * The primary `state` value remains authoritative, including a valid empty
 * portfolio; `_stateBackup1` is used only when the primary value is unusable.
 */
export const getImportString = (storage = localStorage) => {
  const snapshot = loadStateSnapshot(storage);

  if (snapshot.source === 'primary') return snapshot.rawState;
  if (snapshot.source === 'backup') return snapshot.rawBackup;
  return null;
};

const copyWithSelection = (value, documentRef) => {
  if (!documentRef?.body || typeof documentRef.execCommand !== 'function') return false;

  const input = documentRef.createElement('textarea');
  input.value = value;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  documentRef.body.appendChild(input);
  input.select();
  const copied = documentRef.execCommand('copy');
  input.remove();
  return copied;
};

export const copyImportString = async (
  storage = localStorage,
  clipboard = navigator.clipboard,
  documentRef = document
) => {
  const value = getImportString(storage);
  if (typeof value !== 'string') throw new Error('No importable portfolio data is available.');

  if (typeof clipboard?.writeText === 'function') {
    await clipboard.writeText(value);
    return value;
  }

  if (copyWithSelection(value, documentRef)) return value;
  throw new Error('Clipboard access is unavailable.');
};
